import angular from 'angular';
import insuranceFireAndGeneralModal from './insuranceFireAndGeneralModal';

export default angular.module('insuranceFireAndGeneral.scenes', [
  insuranceFireAndGeneralModal,
]).name;
